module.exports = __webpack_public_path__ + "img/Icon - Quiz Versions.b127d426.svg";